import { useEffect, useState } from "react";
import QRCode from "qrcode";

type QrCodeImageProps = {
  value: string;
  alt: string;
  size?: number;
  className?: string;
};

export function QrCodeImage({ value, alt, size = 160, className = "" }: QrCodeImageProps) {
  const [src, setSrc] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    setError("");
    setSrc("");
    QRCode.toDataURL(value, {
      width: size,
      margin: 1,
      errorCorrectionLevel: "M",
      color: {
        dark: "#0f172a",
        light: "#ffffff",
      },
    })
      .then((dataUrl) => {
        if (!cancelled) setSrc(dataUrl);
      })
      .catch((err) => {
        if (!cancelled) setError(err instanceof Error ? err.message : "QR generation failed");
      });
    return () => {
      cancelled = true;
    };
  }, [value, size]);

  if (error) {
    return (
      <div
        className={`grid place-items-center rounded border border-rose-200 bg-rose-50 text-[10px] text-rose-700 ${className}`.trim()}
        aria-label={`${alt} unavailable`}
      >
        QR error
      </div>
    );
  }

  if (!src) {
    return (
      <div
        className={`grid place-items-center rounded border border-slate-200 bg-white text-[10px] text-slate-500 ${className}`.trim()}
        aria-label={`${alt} loading`}
      >
        Loading QR
      </div>
    );
  }

  return <img src={src} alt={alt} className={className} width={size} height={size} />;
}
